import { render, staticRenderFns } from "./AdminCategory.vue?vue&type=template&id=63c20c3e&scoped=true&"
import script from "./AdminCategory.vue?vue&type=script&lang=js&"
export * from "./AdminCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategory.vue?vue&type=style&index=0&id=63c20c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c20c3e",
  null
  
)

export default component.exports